<template id="switch-button">
    <div class="switch-button-control">
        <div
            class="switch-button"
            :class="{ enabled: isEnabled }"
            @click="toggle"
            :style="{ '--color': color }"
        >
            <div class="button"></div>
        </div>
        <div class="switch-button-label">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'isEnabled',
        event: 'toggle',
    },
    props: {
        isEnabled: Boolean,
        color: {
            type: String,
            required: false,
            default: '#60CF43',
        },
    },
    methods: {
        toggle: function () {
            this.$emit('toggle', !this.isEnabled);
        },
    },
};
</script>

<style lang="scss" scoped>
.switch-button-control {
    display: flex;
    flex-direction: row;
    align-items: center;

    .switch-button {
        $switch-button-height: 1.6em;
        $switch-button-color: var(--color);
        $switch-button-border-thickness: 2px;
        $switch-transition: all 0.3s ease-in-out;
        $switch-is-rounded: true;
        $inactive-color: #a9a9a9;

        height: $switch-button-height;
        width: calc(#{$switch-button-height} * 1.5);
        border: $switch-button-border-thickness solid $inactive-color;
        border-radius: if($switch-is-rounded, $switch-button-height, 0);
        background-color: $inactive-color;
        transition: $switch-transition;

        $button-side-length: calc(
            #{$switch-button-height} - (2 * #{$switch-button-border-thickness})
        );

        cursor: pointer;

        .button {
            height: $button-side-length;
            width: $button-side-length;
            border: $switch-button-border-thickness solid $inactive-color;
            border-radius: if($switch-is-rounded, $button-side-length, 0);
            background: white;

            transition: $switch-transition;
        }

        &.enabled {
            background-color: $switch-button-color;
            border: $switch-button-border-thickness solid $switch-button-color;
            box-shadow: none;

            .button {
                background: white;
                border: $switch-button-border-thickness solid $switch-button-color;
                transform: translateX(
                    calc(
                        #{$switch-button-height} * 1.5 - (#{$button-side-length} + (2 *#{$switch-button-border-thickness}))
                    )
                );
            }
        }
    }

    .switch-button-label {
        margin-left: 10px;
    }
}
</style>
